// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface-color);
  overflow: hidden;
  transition: background-color 0.3s ease;
  --scrollbar-track-color: rgba(229, 231, 235, 0.8);
  --scrollbar-thumb-color: rgba(107, 114, 128, 0.85);
  --app-header-padding-block: clamp(0.95rem, calc(0.21rem + 1.54vh), 1.25rem);
  --app-header-padding-left: 1.9rem;
  --app-header-padding-right: 1.9rem;
  --app-title-size: clamp(2.08rem, calc(1.22rem + 1.8vh), 2.43rem);
  --app-subtitle-size: clamp(0.8rem, calc(0.455rem + 0.72vh), 0.94rem);
  --app-logo-width: clamp(290px, calc(162px + 16.67vh), 342px);
  --app-logo-height: clamp(51px, calc(28.85px + 2.89vh), 60px);
  --app-left-panel-width: clamp(250px, 18vw, 350px);
  --app-right-panel-width: clamp(260px, 18vw, 350px);
  --app-left-panel-collapsed-peer-width: clamp(235px, 16vw, 315px);
  --app-right-panel-expanded-with-left-collapsed: clamp(275px, 19vw, 370px);
  --app-collapsed-panel-width: 40px;
  --app-chat-header-padding-block: 1.21rem;
  --app-chat-header-padding-inline: 1.9rem;
  --app-sidebar-header-padding: 1.42rem 1.18rem 0.98rem;
  --app-sidebar-content-padding-inline: 1.18rem;
  --app-wheel-control-width: 79px;
  --app-wheel-control-height: 40px;
}

.App.dark {
  background: #1f2937;
  --scrollbar-track-color: #1c2630;
  --scrollbar-thumb-color: #4b5563;
}

.App,
.App * {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb-color) transparent;
}

.App ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.App ::-webkit-scrollbar-track {
  background: var(--scrollbar-track-color);
  border-radius: 999px;
}

.App ::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb-color);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.App-title {
  position: relative;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:
    var(--app-header-padding-block)
    var(--app-header-padding-right)
    var(--app-header-padding-block)
    var(--app-header-padding-left);
  border-bottom: 1px solid #e5e7eb;
  background: inherit;
  view-transition-name: aimie-app-header;
  transition: all 0.3s ease;
}

::view-transition-group(aimie-app-header) {
  z-index: 10000;
  animation: none;
}

::view-transition-old(aimie-app-header),
::view-transition-new(aimie-app-header) {
  animation: none;
}

.App.dark .App-title {
  border-bottom-color: #374151;
}

.App-title-text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.App-title h1 {
  font-size: var(--app-title-size);
  margin: 0;
  font-weight: 700;
  color: #1f2937;
  letter-spacing: 0;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.App.dark .App-title h1 {
  color: #f9fafb;
}

.App-subtitle {
  margin: 0;
  font-size: var(--app-subtitle-size);
  color: #4b5563;
  line-height: 1.2;
}

.App.dark .App-subtitle {
  color: #d1d5db;
}

.title-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.uoft-logo {
  width: var(--app-logo-width);
  height: var(--app-logo-height);
  object-fit: contain;
  display: block;
  max-width: 100%;
}

.App.dark .uoft-logo {
  filter: brightness(0) invert(1);
}

.collapse-icon {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: transform 0.2s ease;
}

.menu-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  transform: translateY(-0.25rem);
}

.hamburger-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
}

.hamburger-menu span {
  width: 100%;
  height: 2px;
  background-color: #374151;
  border-radius: 2px;
  transition: all 0.2s ease;
}

.dark .hamburger-menu span {
  background-color: #9ca3af;
}

.hamburger-menu:hover span {
  background-color: #111827;
}

.dark .hamburger-menu:hover span {
  background-color: #f9fafb;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--surface-color);
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  z-index: 1000;
  overflow: visible;
  transition: all 0.3s ease;
}

.dropdown-menu--floating {
  position: relative;
  top: auto;
  right: auto;
  width: auto;
  min-width: 180px;
  max-width: min(240px, calc(100vw - 16px));
  /* Must stay visible on both axes: submenus are absolutely positioned
     outside this box (side-opening), and any overflow clipping here hides
     them entirely. Do not add max-height/overflow scrolling back. */
  overflow: visible;
  transition: none;
}

.dropdown-menu-portal {
  position: fixed;
  z-index: 50000;
  pointer-events: none;
}

.dropdown-menu-portal > .dropdown-menu--floating {
  pointer-events: auto;
}

.dark .dropdown-menu {
  background: #111827;
  border-color: #374151;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.menu-section {
  padding: 0.5rem 0;
}

.menu-label {
  padding: 0.5rem 1rem;
  font-size: 0.74rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.dark .menu-label {
  color: #9ca3af;
}

.menu-item {
  width: 100%;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  text-align: left;
  font-size: 0.86rem;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.menu-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.dark .menu-item {
  color: #d1d5db;
}

.menu-item:hover {
  background-color: #f3f4f6;
}

.dark .menu-item:hover {
  background-color: #374151;
}

.menu-item.active {
  background-color: #e5e7eb;
  font-weight: 600;
  color: #111827;
}

.dark .menu-item.active {
  background-color: #4b5563;
  color: #f9fafb;
}

.menu-item-with-submenu {
  position: relative;
}

.language-submenu {
  position: fixed;
  background: var(--surface-color);
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 160px;
  z-index: 9999;
  overflow: hidden;
}

.dark .language-submenu {
  background: #111827;
  border-color: #374151;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.App-layout {
  display: grid;
  grid-template-columns: var(--app-left-panel-width) minmax(0, 1fr) var(--app-right-panel-width);
  flex: 1 1;
  overflow: hidden;
  border-radius: 0;
  min-height: 0;
  transition: grid-template-columns 0.3s ease;
  position: relative;
}

.App-layout.sidebar-collapsed {
  grid-template-columns: var(--app-collapsed-panel-width) minmax(0, 1fr) var(--app-right-panel-expanded-with-left-collapsed);
}

.App-layout.insights-collapsed {
  grid-template-columns: var(--app-left-panel-collapsed-peer-width) minmax(0, 1fr) var(--app-collapsed-panel-width);
}

.App-layout.sidebar-collapsed.insights-collapsed {
  grid-template-columns: var(--app-collapsed-panel-width) minmax(0, 1fr) var(--app-collapsed-panel-width);
}

.single-column-panel-menu {
  display: none;
}

@keyframes single-column-drawer-in {
  from { transform: translateX(-100%); }
  to { transform: translateX(0); }
}

@keyframes single-column-drawer-out {
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
}

@media (max-width: 1680px) {
  .App {
    --app-header-padding-right: 1.6rem;
    --app-chat-header-padding-inline: 1.6rem;
    --app-sidebar-content-padding-inline: 1rem;
  }
}

@media (max-width: 1536px) {
  .App {
    --app-header-padding-right: 1.35rem;
    --app-chat-header-padding-inline: 1.35rem;
  }
}

@media (max-width: 1366px) {
  .App {
    --app-header-padding-right: 1.1rem;
    --app-chat-header-padding-inline: 1.1rem;
    --app-sidebar-content-padding-inline: 0.9rem;
  }
}

@media (max-width: 1200px) {
  .App {
    --app-header-padding-right: 1rem;
    --app-chat-header-padding-inline: 1rem;
    --app-sidebar-content-padding-inline: 0.8rem;
  }
}

@media (max-width: 816px) {
  .App.App--single-column {
    --app-chat-header-padding-block: 0.82rem;
  }

  .App.App--single-column .App-title {
    display: none;
  }

  .single-column-panel-menu {
    display: inline-flex;
    align-items: center;
    gap: 0.85rem;
    position: absolute;
    top: 0.9rem;
    left: 1rem;
    z-index: 40;
  }

  .App.App--single-column-skill-popup-open .single-column-panel-menu {
    opacity: 0;
    pointer-events: none;
  }

  .App.App--single-column-skill-popup-open.App--single-column-drawer-open .single-column-panel-menu {
    opacity: 1;
    pointer-events: auto;
  }

  .single-column-panel-menu--below-chat-header {
    top: calc(4.35rem + 0.55rem);
  }

  .single-column-panel-menu > .cumulative-topics--mobile {
    position: absolute;
    left: calc(100vw - 4.2rem);
    top: 50%;
    transform: translateY(-50%);
    transition: opacity 260ms ease, filter 260ms ease;
  }

  .App.App--single-column-drawer-open .single-column-panel-menu > .cumulative-topics--mobile {
    opacity: 0.45;
    filter: blur(2.5px);
    pointer-events: none;
  }

  .App.App--single-column .App-layout {
    transition: opacity 260ms ease, filter 260ms ease;
  }

  .App.App--single-column-drawer-open .App-layout {
    opacity: 0.45;
    filter: blur(2.5px);
    pointer-events: none;
  }

  .single-column-panel-menu__trigger {
    width: 1.75rem;
    height: 1.35rem;
    border: 0;
    border-radius: 0;
    background: transparent;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0.28rem;
    padding: 0;
    cursor: pointer;
    box-shadow: none;
    transition: opacity 0.2s ease;
  }

  .single-column-panel-menu__trigger:hover {
    opacity: 0.72;
  }

  .single-column-panel-menu__trigger--selection-cue {
    opacity: 1;
    filter:
      drop-shadow(0 0 4px rgba(59, 130, 246, 1))
      drop-shadow(0 0 16px rgba(59, 130, 246, 0.9))
      drop-shadow(0 0 28px rgba(59, 130, 246, 0.55));
  }

  .single-column-panel-menu__trigger--selection-cue:hover {
    opacity: 1;
  }

  .single-column-panel-menu__line {
    display: block;
    height: 2px;
    border-radius: 999px;
    background: #374151;
  }

  .single-column-panel-menu__line--top {
    width: 1.42rem;
  }

  .single-column-panel-menu__line--bottom {
    width: 0.9rem;
  }

  .App.dark .single-column-panel-menu__trigger {
    background: transparent;
  }

  .App.dark .single-column-panel-menu__trigger:hover {
    background: transparent;
  }

  .App.dark .single-column-panel-menu__line {
    background: #f9fafb;
  }

  .App.dark .single-column-panel-menu__trigger--selection-cue {
    filter:
      drop-shadow(0 0 4px rgba(96, 165, 250, 1))
      drop-shadow(0 0 16px rgba(96, 165, 250, 0.78))
      drop-shadow(0 0 28px rgba(96, 165, 250, 0.45));
  }

  .single-column-panel-menu__drawer {
    animation: single-column-drawer-in 260ms cubic-bezier(0.32, 0.72, 0, 1);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: min(clamp(19.5rem, 72vw, 25rem), calc(100vw - 0.75rem));
    height: 100dvh;
    z-index: 70;
    border-right: 1px solid #d1d5db;
    background: var(--surface-panel-color);
    display: flex;
    flex-direction: column;
    overscroll-behavior: contain;
  }

  /* Held mounted by App.jsx for the length of this animation, then removed. */
  .single-column-panel-menu__drawer--closing {
    animation: single-column-drawer-out 260ms cubic-bezier(0.32, 0.72, 0, 1) forwards;
    pointer-events: none;
  }

  .single-column-panel-menu__drawer-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    overscroll-behavior: contain;
    padding: 3.45rem 1.05rem 0.75rem;
    display: flex;
    flex-direction: column;
  }

  /* Live analytics scroll straight into the turn navigator; the bottom padding
     would clip them short and leave an empty strip above the navigator. */
  .single-column-panel-menu__drawer-body:has(.single-column-observer-tabs):not(:has(.single-column-session-action-dock)):has(+ .single-column-panel-menu__turn-navigator) {
    padding-bottom: 0;
  }

  .App.dark .single-column-panel-menu__drawer {
    background: #1c2630;
    border-color: #4b5563;
  }

  .single-column-panel-menu__brand {
    position: absolute;
    top: 0.62rem;
    left: 1rem;
    border: 0;
    background: transparent;
    color: #1f2937;
    cursor: pointer;
    font-family: inherit;
    font-size: 1.55rem;
    font-weight: 800;
    line-height: 1.75rem;
    letter-spacing: 0;
    padding: 0;
  }

  .single-column-panel-menu__brand:hover {
    color: #0f172a;
  }

  .App.dark .single-column-panel-menu__brand {
    color: #f9fafb;
  }

  .App.dark .single-column-panel-menu__brand:hover {
    color: #ffffff;
  }

  .single-column-panel-menu__close {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    width: 1.75rem;
    height: 1.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #9ca3af;
    transition: color 0.15s;
    z-index: 1;
  }

  .single-column-panel-menu__close:hover {
    color: #374151;
  }

  .App.dark .single-column-panel-menu__close {
    color: #6b7280;
  }

  .App.dark .single-column-panel-menu__close:hover {
    color: #e5e7eb;
  }

  .single-column-panel-menu__close svg {
    width: 1.1rem;
    height: 1.1rem;
  }

  .single-column-panel-menu__turn-navigator {
    flex: 0 0 auto;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 0.3rem 0.55rem;
    padding: 0.34rem 0.8rem;
    background: transparent;
    border-top-color: rgba(148, 163, 184, 0.35);
  }

  .single-column-panel-menu__turn-navigator .turn-navigator-title {
    font-size: 0.62rem;
    letter-spacing: 0.06em;
    text-align: left;
  }

  .single-column-panel-menu__turn-navigator .turn-navigator-controls {
    gap: 0.4rem;
  }

  .single-column-panel-menu__turn-navigator .turn-nav-btn {
    width: 24px;
    height: 24px;
  }

  .single-column-panel-menu__turn-navigator .turn-nav-btn svg {
    width: 14px;
    height: 14px;
  }

  .single-column-panel-menu__turn-navigator .turn-indicator {
    min-width: 0;
    font-size: 0.74rem;
    gap: 0.35rem;
  }

  .App.dark .single-column-panel-menu__turn-navigator {
    background: transparent;
    border-top-color: rgba(75, 85, 99, 0.75);
  }

  .single-column-panel-menu__account-footer {
    flex: 0 0 auto;
    padding: 0.42rem 0.8rem calc(0.42rem + env(safe-area-inset-bottom, 0px));
    border-top: 1px solid rgba(148, 163, 184, 0.35);
  }

  .App.dark .single-column-panel-menu__account-footer {
    border-top-color: rgba(75, 85, 99, 0.75);
  }

  .single-column-panel-menu__account-footer-row {
    display: flex;
    align-items: center;
    gap: 0.55rem;
    min-width: 0;
  }

  .single-column-panel-menu__account-footer .menu-container {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    transform: none;
  }

  .single-column-panel-menu__account-footer .credits-badge-wrap {
    height: auto;
    margin-right: 0;
    flex: 0 0 auto;
  }

  .single-column-panel-menu__account-footer .credits-badge {
    height: 2.05rem;
    padding: 0 0.58rem 0 0.42rem;
    transform: none;
  }

  .single-column-panel-menu__account-footer .credits-badge__coin {
    width: 1.45rem;
    height: 1.45rem;
  }

  .single-column-panel-menu__account-footer .credits-badge__value {
    font-size: 1rem;
  }

  .single-column-panel-menu__account-footer .credits-badge__hover-note {
    top: auto;
    right: 0;
    bottom: calc(100% + 0.55rem);
    left: auto;
    width: min(14.5rem, calc(100vw - 2rem));
  }

  .single-column-account-trigger {
    width: 100%;
    min-height: 2.25rem;
    border: 0;
    border-radius: 0.8rem;
    background: transparent;
    color: #1f2937;
    display: grid;
    grid-template-columns: 1.85rem minmax(0, 1fr);
    align-items: center;
    gap: 0.55rem;
    padding: 0.22rem 0.35rem;
    cursor: pointer;
    font-family: inherit;
    text-align: left;
    transition: background 0.15s ease;
  }

  .single-column-account-trigger:hover,
  .single-column-account-trigger[aria-expanded="true"] {
    background: rgba(148, 163, 184, 0.16);
  }

  .App.dark .single-column-account-trigger {
    color: #f9fafb;
  }

  .App.dark .single-column-account-trigger:hover,
  .App.dark .single-column-account-trigger[aria-expanded="true"] {
    background: rgba(255, 255, 255, 0.07);
  }

  .single-column-account-trigger__avatar {
    width: 1.85rem;
    height: 1.85rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .single-column-account-trigger__avatar svg {
    width: 1.85rem;
    height: 1.85rem;
    display: block;
  }

  .single-column-account-trigger__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.92rem;
    font-weight: 650;
  }

  .App-layout.single-column-layout,
  .App-layout.single-column-layout.sidebar-collapsed,
  .App-layout.single-column-layout.insights-collapsed,
  .App-layout.single-column-layout.sidebar-collapsed.insights-collapsed {
    display: block;
    grid-template-columns: none;
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
    transition: none;
  }

  .App-layout.single-column-layout > .app-overlay-root {
    position: absolute;
    inset: 0;
    z-index: 60000;
  }

  .App-layout.single-column-layout > .client-sidebar,
  .App-layout.single-column-layout > .chat-interface,
  .App-layout.single-column-layout > .report-panel {
    display: none;
    width: 100%;
    max-width: none;
    min-width: 0;
    height: 100%;
    border-left: 0;
    border-right: 0;
  }

  .App-layout.single-column-layout.active-panel-client > .client-sidebar,
  .App-layout.single-column-layout.active-panel-chat > .chat-interface,
  .App-layout.single-column-layout.active-panel-analytics > .report-panel {
    display: flex;
    position: relative;
    z-index: 1;
  }
}

@media (max-width: 768px) {
  .App {
    height: auto;
    min-height: 100vh;
    overflow: auto;
    padding-bottom: 1.5rem;
  }

  .App-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 1rem 1rem;
  }

  .App-title h1 {
    font-size: 1.5rem;
  }

  .App-subtitle {
    font-size: 0.8rem;
  }

  .title-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .uoft-logo {
    width: 230px;
    height: 40px;
  }

  .App-layout,
  .App-layout.sidebar-collapsed,
  .App-layout.insights-collapsed,
  .App-layout.sidebar-collapsed.insights-collapsed {
    display: flex;
    flex-direction: column;
    grid-template-columns: none;
    grid-template-rows: none;
    gap: 0.75rem;
    padding: 0 0.75rem 1.5rem;
    height: auto;
    overflow: visible;
  }

  .App-layout > * {
    width: 100%;
    height: auto;
    min-height: auto;
  }

  .App-layout .client-sidebar {
    order: 1;
  }

  .App-layout .chat-interface {
    order: 2;
    min-height: 60vh;
  }

  .App-layout .report-panel {
    order: 3;
  }

  .App.App--single-column {
    height: 100vh;
    height: 100dvh;
    min-height: 0;
    overflow: hidden;
    padding-bottom: 0;
  }

  .App.App--single-column .App-title {
    display: none;
  }

  .App.App--single-column .App-layout,
  .App.App--single-column .App-layout.sidebar-collapsed,
  .App.App--single-column .App-layout.insights-collapsed,
  .App.App--single-column .App-layout.sidebar-collapsed.insights-collapsed {
    display: block;
    grid-template-columns: none;
    grid-template-rows: none;
    gap: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;
  }

  .App.App--single-column .App-layout > * {
    width: 100%;
    height: 100%;
    min-height: 0;
  }

}
/* ── Shared MITI code chips ───────────────────────────────────────────────── */
/* Used in OARSInterface, ReportPanel INTERACTION LOG, and any MITI display   */
.miti-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  border: 1px solid transparent;
  white-space: nowrap;
}

/* OARS-aligned codes */
.miti-chip--Q          { background: rgba(74,158,255,0.15);  color: #4a9eff; border-color: rgba(74,158,255,0.35); }
.miti-chip--S          { background: rgba(240,168,78,0.15);  color: #f0a84e; border-color: rgba(240,168,78,0.35); }
.miti-chip--AF         { background: rgba(76,175,136,0.15);  color: #4caf88; border-color: rgba(76,175,136,0.35); }
.miti-chip--SR         { background: rgba(47,158,158,0.15);  color: #2f9e9e; border-color: rgba(47,158,158,0.35); }
.miti-chip--CR         { background: rgba(201,126,240,0.15); color: #c97ef0; border-color: rgba(201,126,240,0.35); }
.miti-chip--Seek       { background: rgba(240,168,78,0.15);  color: #f0a84e; border-color: rgba(240,168,78,0.35); }

/* Other MITI codes */
.miti-chip--GI         { background: rgba(56,189,248,0.15);  color: #38bdf8; border-color: rgba(56,189,248,0.35); }
.miti-chip--Persuade   { background: rgba(251,113,133,0.15); color: #fb7185; border-color: rgba(251,113,133,0.35); }
.miti-chip--Persuade_with { background: rgba(251,146,60,0.15); color: #fb923c; border-color: rgba(251,146,60,0.35); }
.miti-chip--Emphasize  { background: rgba(52,211,153,0.15);  color: #34d399; border-color: rgba(52,211,153,0.35); }
.miti-chip--Confront   { background: rgba(239,68,68,0.15);   color: #ef4444; border-color: rgba(239,68,68,0.35); }
.miti-chip--NC         { background: rgba(156,163,175,0.12); color: #9ca3af; border-color: rgba(156,163,175,0.3); }

@media (prefers-reduced-motion: reduce) {
  .single-column-panel-menu__drawer,
  .single-column-panel-menu__drawer--closing {
    animation-duration: 1ms;
  }

  .App.App--single-column .App-layout {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,sCAAsC;EACtC,iDAAiD;EACjD,kDAAkD;EAClD,2EAA2E;EAC3E,iCAAiC;EACjC,kCAAkC;EAClC,gEAAgE;EAChE,oEAAoE;EACpE,4DAA4D;EAC5D,4DAA4D;EAC5D,iDAAiD;EACjD,kDAAkD;EAClD,gEAAgE;EAChE,yEAAyE;EACzE,iCAAiC;EACjC,wCAAwC;EACxC,wCAAwC;EACxC,qDAAqD;EACrD,6CAA6C;EAC7C,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;;;;kCAIgC;EAChC,gCAAgC;EAChC,mBAAmB;EACnB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC;;oEAEkE;EAClE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8FAA8F;EAC9F,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,0HAA0H;AAC5H;;AAEA;EACE,iHAAiH;AACnH;;AAEA;EACE,uGAAuG;AACzG;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE;IACE,kCAAkC;IAClC,wCAAwC;IACxC,0CAA0C;EAC5C;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,wCAAwC;IACxC,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,sCAAsC;IACtC,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,QAAQ;IACR,2BAA2B;IAC3B,iDAAiD;EACnD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV;;;oDAGgD;EAClD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;;;oDAGgD;EAClD;;EAEA;IACE,uEAAuE;IACvE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,8DAA8D;IAC9D,cAAc;IACd,WAAW;IACX,+BAA+B;IAC/B,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA,4EAA4E;EAC5E;IACE,iFAAiF;IACjF,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,gCAAgC;IAChC,aAAa;IACb,sBAAsB;EACxB;;EAEA;0EACwE;EACxE;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,cAAc;IACd,wEAAwE;IACxE,+CAA+C;EACjD;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,4BAA4B;IAC5B,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,6CAA6C;IAC7C,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;;;IAIE,cAAc;IACd,2BAA2B;IAC3B,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,cAAc;EAChB;;EAEA;;;IAGE,aAAa;IACb,WAAW;IACX,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;;;IAGE,aAAa;IACb,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;;;;IAIE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,2BAA2B;IAC3B,wBAAwB;IACxB,MAAM;IACN,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;AAEF;AACA,gFAAgF;AAChF,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB,yBAAyB,iCAAiC,GAAG,cAAc,EAAE,mCAAmC,EAAE;AAClH,yBAAyB,iCAAiC,GAAG,cAAc,EAAE,mCAAmC,EAAE;AAClH,yBAAyB,iCAAiC,GAAG,cAAc,EAAE,mCAAmC,EAAE;AAClH,yBAAyB,iCAAiC,GAAG,cAAc,EAAE,mCAAmC,EAAE;AAClH,yBAAyB,kCAAkC,EAAE,cAAc,EAAE,oCAAoC,EAAE;AACnH,yBAAyB,iCAAiC,GAAG,cAAc,EAAE,mCAAmC,EAAE;;AAElH,qBAAqB;AACrB,yBAAyB,iCAAiC,GAAG,cAAc,EAAE,mCAAmC,EAAE;AAClH,yBAAyB,kCAAkC,EAAE,cAAc,EAAE,oCAAoC,EAAE;AACnH,4BAA4B,iCAAiC,EAAE,cAAc,EAAE,mCAAmC,EAAE;AACpH,yBAAyB,iCAAiC,GAAG,cAAc,EAAE,mCAAmC,EAAE;AAClH,yBAAyB,gCAAgC,IAAI,cAAc,EAAE,kCAAkC,EAAE;AACjH,yBAAyB,kCAAkC,EAAE,cAAc,EAAE,mCAAmC,EAAE;;AAElH;EACE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".App {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-color);\n  overflow: hidden;\n  transition: background-color 0.3s ease;\n  --scrollbar-track-color: rgba(229, 231, 235, 0.8);\n  --scrollbar-thumb-color: rgba(107, 114, 128, 0.85);\n  --app-header-padding-block: clamp(0.95rem, calc(0.21rem + 1.54vh), 1.25rem);\n  --app-header-padding-left: 1.9rem;\n  --app-header-padding-right: 1.9rem;\n  --app-title-size: clamp(2.08rem, calc(1.22rem + 1.8vh), 2.43rem);\n  --app-subtitle-size: clamp(0.8rem, calc(0.455rem + 0.72vh), 0.94rem);\n  --app-logo-width: clamp(290px, calc(162px + 16.67vh), 342px);\n  --app-logo-height: clamp(51px, calc(28.85px + 2.89vh), 60px);\n  --app-left-panel-width: clamp(250px, 18vw, 350px);\n  --app-right-panel-width: clamp(260px, 18vw, 350px);\n  --app-left-panel-collapsed-peer-width: clamp(235px, 16vw, 315px);\n  --app-right-panel-expanded-with-left-collapsed: clamp(275px, 19vw, 370px);\n  --app-collapsed-panel-width: 40px;\n  --app-chat-header-padding-block: 1.21rem;\n  --app-chat-header-padding-inline: 1.9rem;\n  --app-sidebar-header-padding: 1.42rem 1.18rem 0.98rem;\n  --app-sidebar-content-padding-inline: 1.18rem;\n  --app-wheel-control-width: 79px;\n  --app-wheel-control-height: 40px;\n}\n\n.App.dark {\n  background: #1f2937;\n  --scrollbar-track-color: #1c2630;\n  --scrollbar-thumb-color: #4b5563;\n}\n\n.App,\n.App * {\n  scrollbar-width: thin;\n  scrollbar-color: var(--scrollbar-thumb-color) transparent;\n}\n\n.App ::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.App ::-webkit-scrollbar-track {\n  background: var(--scrollbar-track-color);\n  border-radius: 999px;\n}\n\n.App ::-webkit-scrollbar-thumb {\n  background-color: var(--scrollbar-thumb-color);\n  border-radius: 999px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n.App-title {\n  position: relative;\n  z-index: 1000;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding:\n    var(--app-header-padding-block)\n    var(--app-header-padding-right)\n    var(--app-header-padding-block)\n    var(--app-header-padding-left);\n  border-bottom: 1px solid #e5e7eb;\n  background: inherit;\n  view-transition-name: aimie-app-header;\n  transition: all 0.3s ease;\n}\n\n::view-transition-group(aimie-app-header) {\n  z-index: 10000;\n  animation: none;\n}\n\n::view-transition-old(aimie-app-header),\n::view-transition-new(aimie-app-header) {\n  animation: none;\n}\n\n.App.dark .App-title {\n  border-bottom-color: #374151;\n}\n\n.App-title-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.App-title h1 {\n  font-size: var(--app-title-size);\n  margin: 0;\n  font-weight: 700;\n  color: #1f2937;\n  letter-spacing: 0;\n  line-height: 1.5;\n  transition: color 0.3s ease;\n}\n\n.App.dark .App-title h1 {\n  color: #f9fafb;\n}\n\n.App-subtitle {\n  margin: 0;\n  font-size: var(--app-subtitle-size);\n  color: #4b5563;\n  line-height: 1.2;\n}\n\n.App.dark .App-subtitle {\n  color: #d1d5db;\n}\n\n.title-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.uoft-logo {\n  width: var(--app-logo-width);\n  height: var(--app-logo-height);\n  object-fit: contain;\n  display: block;\n  max-width: 100%;\n}\n\n.App.dark .uoft-logo {\n  filter: brightness(0) invert(1);\n}\n\n.collapse-icon {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  transition: transform 0.2s ease;\n}\n\n.menu-container {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  transform: translateY(-0.25rem);\n}\n\n.hamburger-menu {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 24px;\n  height: 18px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  transition: all 0.2s ease;\n}\n\n.hamburger-menu span {\n  width: 100%;\n  height: 2px;\n  background-color: #374151;\n  border-radius: 2px;\n  transition: all 0.2s ease;\n}\n\n.dark .hamburger-menu span {\n  background-color: #9ca3af;\n}\n\n.hamburger-menu:hover span {\n  background-color: #111827;\n}\n\n.dark .hamburger-menu:hover span {\n  background-color: #f9fafb;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  background: var(--surface-color);\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  min-width: 180px;\n  z-index: 1000;\n  overflow: visible;\n  transition: all 0.3s ease;\n}\n\n.dropdown-menu--floating {\n  position: relative;\n  top: auto;\n  right: auto;\n  width: auto;\n  min-width: 180px;\n  max-width: min(240px, calc(100vw - 16px));\n  /* Must stay visible on both axes: submenus are absolutely positioned\n     outside this box (side-opening), and any overflow clipping here hides\n     them entirely. Do not add max-height/overflow scrolling back. */\n  overflow: visible;\n  transition: none;\n}\n\n.dropdown-menu-portal {\n  position: fixed;\n  z-index: 50000;\n  pointer-events: none;\n}\n\n.dropdown-menu-portal > .dropdown-menu--floating {\n  pointer-events: auto;\n}\n\n.dark .dropdown-menu {\n  background: #111827;\n  border-color: #374151;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n}\n\n.menu-section {\n  padding: 0.5rem 0;\n}\n\n.menu-label {\n  padding: 0.5rem 1rem;\n  font-size: 0.74rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: color 0.3s ease;\n}\n\n.dark .menu-label {\n  color: #9ca3af;\n}\n\n.menu-item {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  text-align: left;\n  font-size: 0.86rem;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.menu-icon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.dark .menu-item {\n  color: #d1d5db;\n}\n\n.menu-item:hover {\n  background-color: #f3f4f6;\n}\n\n.dark .menu-item:hover {\n  background-color: #374151;\n}\n\n.menu-item.active {\n  background-color: #e5e7eb;\n  font-weight: 600;\n  color: #111827;\n}\n\n.dark .menu-item.active {\n  background-color: #4b5563;\n  color: #f9fafb;\n}\n\n.menu-item-with-submenu {\n  position: relative;\n}\n\n.language-submenu {\n  position: fixed;\n  background: var(--surface-color);\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  min-width: 160px;\n  z-index: 9999;\n  overflow: hidden;\n}\n\n.dark .language-submenu {\n  background: #111827;\n  border-color: #374151;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);\n}\n\n.App-layout {\n  display: grid;\n  grid-template-columns: var(--app-left-panel-width) minmax(0, 1fr) var(--app-right-panel-width);\n  flex: 1;\n  overflow: hidden;\n  border-radius: 0;\n  min-height: 0;\n  transition: grid-template-columns 0.3s ease;\n  position: relative;\n}\n\n.App-layout.sidebar-collapsed {\n  grid-template-columns: var(--app-collapsed-panel-width) minmax(0, 1fr) var(--app-right-panel-expanded-with-left-collapsed);\n}\n\n.App-layout.insights-collapsed {\n  grid-template-columns: var(--app-left-panel-collapsed-peer-width) minmax(0, 1fr) var(--app-collapsed-panel-width);\n}\n\n.App-layout.sidebar-collapsed.insights-collapsed {\n  grid-template-columns: var(--app-collapsed-panel-width) minmax(0, 1fr) var(--app-collapsed-panel-width);\n}\n\n.single-column-panel-menu {\n  display: none;\n}\n\n@keyframes single-column-drawer-in {\n  from { transform: translateX(-100%); }\n  to { transform: translateX(0); }\n}\n\n@keyframes single-column-drawer-out {\n  from { transform: translateX(0); }\n  to { transform: translateX(-100%); }\n}\n\n@media (max-width: 1680px) {\n  .App {\n    --app-header-padding-right: 1.6rem;\n    --app-chat-header-padding-inline: 1.6rem;\n    --app-sidebar-content-padding-inline: 1rem;\n  }\n}\n\n@media (max-width: 1536px) {\n  .App {\n    --app-header-padding-right: 1.35rem;\n    --app-chat-header-padding-inline: 1.35rem;\n  }\n}\n\n@media (max-width: 1366px) {\n  .App {\n    --app-header-padding-right: 1.1rem;\n    --app-chat-header-padding-inline: 1.1rem;\n    --app-sidebar-content-padding-inline: 0.9rem;\n  }\n}\n\n@media (max-width: 1200px) {\n  .App {\n    --app-header-padding-right: 1rem;\n    --app-chat-header-padding-inline: 1rem;\n    --app-sidebar-content-padding-inline: 0.8rem;\n  }\n}\n\n@media (max-width: 816px) {\n  .App.App--single-column {\n    --app-chat-header-padding-block: 0.82rem;\n  }\n\n  .App.App--single-column .App-title {\n    display: none;\n  }\n\n  .single-column-panel-menu {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.85rem;\n    position: absolute;\n    top: 0.9rem;\n    left: 1rem;\n    z-index: 40;\n  }\n\n  .App.App--single-column-skill-popup-open .single-column-panel-menu {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .App.App--single-column-skill-popup-open.App--single-column-drawer-open .single-column-panel-menu {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .single-column-panel-menu--below-chat-header {\n    top: calc(4.35rem + 0.55rem);\n  }\n\n  .single-column-panel-menu > .cumulative-topics--mobile {\n    position: absolute;\n    left: calc(100vw - 4.2rem);\n    top: 50%;\n    transform: translateY(-50%);\n    transition: opacity 260ms ease, filter 260ms ease;\n  }\n\n  .App.App--single-column-drawer-open .single-column-panel-menu > .cumulative-topics--mobile {\n    opacity: 0.45;\n    filter: blur(2.5px);\n    pointer-events: none;\n  }\n\n  .App.App--single-column .App-layout {\n    transition: opacity 260ms ease, filter 260ms ease;\n  }\n\n  .App.App--single-column-drawer-open .App-layout {\n    opacity: 0.45;\n    filter: blur(2.5px);\n    pointer-events: none;\n  }\n\n  .single-column-panel-menu__trigger {\n    width: 1.75rem;\n    height: 1.35rem;\n    border: 0;\n    border-radius: 0;\n    background: transparent;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 0.28rem;\n    padding: 0;\n    cursor: pointer;\n    box-shadow: none;\n    transition: opacity 0.2s ease;\n  }\n\n  .single-column-panel-menu__trigger:hover {\n    opacity: 0.72;\n  }\n\n  .single-column-panel-menu__trigger--selection-cue {\n    opacity: 1;\n    filter:\n      drop-shadow(0 0 4px rgba(59, 130, 246, 1))\n      drop-shadow(0 0 16px rgba(59, 130, 246, 0.9))\n      drop-shadow(0 0 28px rgba(59, 130, 246, 0.55));\n  }\n\n  .single-column-panel-menu__trigger--selection-cue:hover {\n    opacity: 1;\n  }\n\n  .single-column-panel-menu__line {\n    display: block;\n    height: 2px;\n    border-radius: 999px;\n    background: #374151;\n  }\n\n  .single-column-panel-menu__line--top {\n    width: 1.42rem;\n  }\n\n  .single-column-panel-menu__line--bottom {\n    width: 0.9rem;\n  }\n\n  .App.dark .single-column-panel-menu__trigger {\n    background: transparent;\n  }\n\n  .App.dark .single-column-panel-menu__trigger:hover {\n    background: transparent;\n  }\n\n  .App.dark .single-column-panel-menu__line {\n    background: #f9fafb;\n  }\n\n  .App.dark .single-column-panel-menu__trigger--selection-cue {\n    filter:\n      drop-shadow(0 0 4px rgba(96, 165, 250, 1))\n      drop-shadow(0 0 16px rgba(96, 165, 250, 0.78))\n      drop-shadow(0 0 28px rgba(96, 165, 250, 0.45));\n  }\n\n  .single-column-panel-menu__drawer {\n    animation: single-column-drawer-in 260ms cubic-bezier(0.32, 0.72, 0, 1);\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: min(clamp(19.5rem, 72vw, 25rem), calc(100vw - 0.75rem));\n    height: 100dvh;\n    z-index: 70;\n    border-right: 1px solid #d1d5db;\n    background: var(--surface-panel-color);\n    display: flex;\n    flex-direction: column;\n    overscroll-behavior: contain;\n  }\n\n  /* Held mounted by App.jsx for the length of this animation, then removed. */\n  .single-column-panel-menu__drawer--closing {\n    animation: single-column-drawer-out 260ms cubic-bezier(0.32, 0.72, 0, 1) forwards;\n    pointer-events: none;\n  }\n\n  .single-column-panel-menu__drawer-body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n    overscroll-behavior: contain;\n    padding: 3.45rem 1.05rem 0.75rem;\n    display: flex;\n    flex-direction: column;\n  }\n\n  /* Live analytics scroll straight into the turn navigator; the bottom padding\n     would clip them short and leave an empty strip above the navigator. */\n  .single-column-panel-menu__drawer-body:has(.single-column-observer-tabs):not(:has(.single-column-session-action-dock)):has(+ .single-column-panel-menu__turn-navigator) {\n    padding-bottom: 0;\n  }\n\n  .App.dark .single-column-panel-menu__drawer {\n    background: #1c2630;\n    border-color: #4b5563;\n  }\n\n  .single-column-panel-menu__brand {\n    position: absolute;\n    top: 0.62rem;\n    left: 1rem;\n    border: 0;\n    background: transparent;\n    color: #1f2937;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 1.55rem;\n    font-weight: 800;\n    line-height: 1.75rem;\n    letter-spacing: 0;\n    padding: 0;\n  }\n\n  .single-column-panel-menu__brand:hover {\n    color: #0f172a;\n  }\n\n  .App.dark .single-column-panel-menu__brand {\n    color: #f9fafb;\n  }\n\n  .App.dark .single-column-panel-menu__brand:hover {\n    color: #ffffff;\n  }\n\n  .single-column-panel-menu__close {\n    position: absolute;\n    top: 0.75rem;\n    right: 0.75rem;\n    width: 1.75rem;\n    height: 1.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    color: #9ca3af;\n    transition: color 0.15s;\n    z-index: 1;\n  }\n\n  .single-column-panel-menu__close:hover {\n    color: #374151;\n  }\n\n  .App.dark .single-column-panel-menu__close {\n    color: #6b7280;\n  }\n\n  .App.dark .single-column-panel-menu__close:hover {\n    color: #e5e7eb;\n  }\n\n  .single-column-panel-menu__close svg {\n    width: 1.1rem;\n    height: 1.1rem;\n  }\n\n  .single-column-panel-menu__turn-navigator {\n    flex: 0 0 auto;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.3rem 0.55rem;\n    padding: 0.34rem 0.8rem;\n    background: transparent;\n    border-top-color: rgba(148, 163, 184, 0.35);\n  }\n\n  .single-column-panel-menu__turn-navigator .turn-navigator-title {\n    font-size: 0.62rem;\n    letter-spacing: 0.06em;\n    text-align: left;\n  }\n\n  .single-column-panel-menu__turn-navigator .turn-navigator-controls {\n    gap: 0.4rem;\n  }\n\n  .single-column-panel-menu__turn-navigator .turn-nav-btn {\n    width: 24px;\n    height: 24px;\n  }\n\n  .single-column-panel-menu__turn-navigator .turn-nav-btn svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .single-column-panel-menu__turn-navigator .turn-indicator {\n    min-width: 0;\n    font-size: 0.74rem;\n    gap: 0.35rem;\n  }\n\n  .App.dark .single-column-panel-menu__turn-navigator {\n    background: transparent;\n    border-top-color: rgba(75, 85, 99, 0.75);\n  }\n\n  .single-column-panel-menu__account-footer {\n    flex: 0 0 auto;\n    padding: 0.42rem 0.8rem calc(0.42rem + env(safe-area-inset-bottom, 0px));\n    border-top: 1px solid rgba(148, 163, 184, 0.35);\n  }\n\n  .App.dark .single-column-panel-menu__account-footer {\n    border-top-color: rgba(75, 85, 99, 0.75);\n  }\n\n  .single-column-panel-menu__account-footer-row {\n    display: flex;\n    align-items: center;\n    gap: 0.55rem;\n    min-width: 0;\n  }\n\n  .single-column-panel-menu__account-footer .menu-container {\n    flex: 1 1 auto;\n    width: auto;\n    min-width: 0;\n    transform: none;\n  }\n\n  .single-column-panel-menu__account-footer .credits-badge-wrap {\n    height: auto;\n    margin-right: 0;\n    flex: 0 0 auto;\n  }\n\n  .single-column-panel-menu__account-footer .credits-badge {\n    height: 2.05rem;\n    padding: 0 0.58rem 0 0.42rem;\n    transform: none;\n  }\n\n  .single-column-panel-menu__account-footer .credits-badge__coin {\n    width: 1.45rem;\n    height: 1.45rem;\n  }\n\n  .single-column-panel-menu__account-footer .credits-badge__value {\n    font-size: 1rem;\n  }\n\n  .single-column-panel-menu__account-footer .credits-badge__hover-note {\n    top: auto;\n    right: 0;\n    bottom: calc(100% + 0.55rem);\n    left: auto;\n    width: min(14.5rem, calc(100vw - 2rem));\n  }\n\n  .single-column-account-trigger {\n    width: 100%;\n    min-height: 2.25rem;\n    border: 0;\n    border-radius: 0.8rem;\n    background: transparent;\n    color: #1f2937;\n    display: grid;\n    grid-template-columns: 1.85rem minmax(0, 1fr);\n    align-items: center;\n    gap: 0.55rem;\n    padding: 0.22rem 0.35rem;\n    cursor: pointer;\n    font-family: inherit;\n    text-align: left;\n    transition: background 0.15s ease;\n  }\n\n  .single-column-account-trigger:hover,\n  .single-column-account-trigger[aria-expanded=\"true\"] {\n    background: rgba(148, 163, 184, 0.16);\n  }\n\n  .App.dark .single-column-account-trigger {\n    color: #f9fafb;\n  }\n\n  .App.dark .single-column-account-trigger:hover,\n  .App.dark .single-column-account-trigger[aria-expanded=\"true\"] {\n    background: rgba(255, 255, 255, 0.07);\n  }\n\n  .single-column-account-trigger__avatar {\n    width: 1.85rem;\n    height: 1.85rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .single-column-account-trigger__avatar svg {\n    width: 1.85rem;\n    height: 1.85rem;\n    display: block;\n  }\n\n  .single-column-account-trigger__name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 0.92rem;\n    font-weight: 650;\n  }\n\n  .App-layout.single-column-layout,\n  .App-layout.single-column-layout.sidebar-collapsed,\n  .App-layout.single-column-layout.insights-collapsed,\n  .App-layout.single-column-layout.sidebar-collapsed.insights-collapsed {\n    display: block;\n    grid-template-columns: none;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    transition: none;\n  }\n\n  .App-layout.single-column-layout > .app-overlay-root {\n    position: absolute;\n    inset: 0;\n    z-index: 60000;\n  }\n\n  .App-layout.single-column-layout > .client-sidebar,\n  .App-layout.single-column-layout > .chat-interface,\n  .App-layout.single-column-layout > .report-panel {\n    display: none;\n    width: 100%;\n    max-width: none;\n    min-width: 0;\n    height: 100%;\n    border-left: 0;\n    border-right: 0;\n  }\n\n  .App-layout.single-column-layout.active-panel-client > .client-sidebar,\n  .App-layout.single-column-layout.active-panel-chat > .chat-interface,\n  .App-layout.single-column-layout.active-panel-analytics > .report-panel {\n    display: flex;\n    position: relative;\n    z-index: 1;\n  }\n}\n\n@media (max-width: 768px) {\n  .App {\n    height: auto;\n    min-height: 100vh;\n    overflow: auto;\n    padding-bottom: 1.5rem;\n  }\n\n  .App-title {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n    padding: 1rem 1rem;\n  }\n\n  .App-title h1 {\n    font-size: 1.5rem;\n  }\n\n  .App-subtitle {\n    font-size: 0.8rem;\n  }\n\n  .title-actions {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .uoft-logo {\n    width: 230px;\n    height: 40px;\n  }\n\n  .App-layout,\n  .App-layout.sidebar-collapsed,\n  .App-layout.insights-collapsed,\n  .App-layout.sidebar-collapsed.insights-collapsed {\n    display: flex;\n    flex-direction: column;\n    grid-template-columns: none;\n    grid-template-rows: none;\n    gap: 0.75rem;\n    padding: 0 0.75rem 1.5rem;\n    height: auto;\n    overflow: visible;\n  }\n\n  .App-layout > * {\n    width: 100%;\n    height: auto;\n    min-height: auto;\n  }\n\n  .App-layout .client-sidebar {\n    order: 1;\n  }\n\n  .App-layout .chat-interface {\n    order: 2;\n    min-height: 60vh;\n  }\n\n  .App-layout .report-panel {\n    order: 3;\n  }\n\n  .App.App--single-column {\n    height: 100vh;\n    height: 100dvh;\n    min-height: 0;\n    overflow: hidden;\n    padding-bottom: 0;\n  }\n\n  .App.App--single-column .App-title {\n    display: none;\n  }\n\n  .App.App--single-column .App-layout,\n  .App.App--single-column .App-layout.sidebar-collapsed,\n  .App.App--single-column .App-layout.insights-collapsed,\n  .App.App--single-column .App-layout.sidebar-collapsed.insights-collapsed {\n    display: block;\n    grid-template-columns: none;\n    grid-template-rows: none;\n    gap: 0;\n    padding: 0;\n    height: 100%;\n    overflow: hidden;\n  }\n\n  .App.App--single-column .App-layout > * {\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n  }\n\n}\n/* ── Shared MITI code chips ───────────────────────────────────────────────── */\n/* Used in OARSInterface, ReportPanel INTERACTION LOG, and any MITI display   */\n.miti-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n/* OARS-aligned codes */\n.miti-chip--Q          { background: rgba(74,158,255,0.15);  color: #4a9eff; border-color: rgba(74,158,255,0.35); }\n.miti-chip--S          { background: rgba(240,168,78,0.15);  color: #f0a84e; border-color: rgba(240,168,78,0.35); }\n.miti-chip--AF         { background: rgba(76,175,136,0.15);  color: #4caf88; border-color: rgba(76,175,136,0.35); }\n.miti-chip--SR         { background: rgba(47,158,158,0.15);  color: #2f9e9e; border-color: rgba(47,158,158,0.35); }\n.miti-chip--CR         { background: rgba(201,126,240,0.15); color: #c97ef0; border-color: rgba(201,126,240,0.35); }\n.miti-chip--Seek       { background: rgba(240,168,78,0.15);  color: #f0a84e; border-color: rgba(240,168,78,0.35); }\n\n/* Other MITI codes */\n.miti-chip--GI         { background: rgba(56,189,248,0.15);  color: #38bdf8; border-color: rgba(56,189,248,0.35); }\n.miti-chip--Persuade   { background: rgba(251,113,133,0.15); color: #fb7185; border-color: rgba(251,113,133,0.35); }\n.miti-chip--Persuade_with { background: rgba(251,146,60,0.15); color: #fb923c; border-color: rgba(251,146,60,0.35); }\n.miti-chip--Emphasize  { background: rgba(52,211,153,0.15);  color: #34d399; border-color: rgba(52,211,153,0.35); }\n.miti-chip--Confront   { background: rgba(239,68,68,0.15);   color: #ef4444; border-color: rgba(239,68,68,0.35); }\n.miti-chip--NC         { background: rgba(156,163,175,0.12); color: #9ca3af; border-color: rgba(156,163,175,0.3); }\n\n@media (prefers-reduced-motion: reduce) {\n  .single-column-panel-menu__drawer,\n  .single-column-panel-menu__drawer--closing {\n    animation-duration: 1ms;\n  }\n\n  .App.App--single-column .App-layout {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
